import { createSlice } from '@reduxjs/toolkit'

interface HopTimusState {
  isLoading: boolean
}

const initialState: HopTimusState = {
  isLoading: false,
}

const activationRequestedHandler = (state: HopTimusState) => {
  state.isLoading = true
}

const activationSettledHandler = (state: HopTimusState) => {
  state.isLoading = false
}

const hopTimusSlice = createSlice({
  name: 'hopTimus',
  initialState,
  reducers: {
    activationRequested: activationRequestedHandler,
    activationSettled: activationSettledHandler,
  },
})

export const { activationRequested, activationSettled } = hopTimusSlice.actions

export default hopTimusSlice.reducer
